import { lazy } from "react";

const Contact = lazy(() => import("../pages/Contact"));
const Home01 = lazy(() => import("../pages/Home01"));
const Deborah = lazy(() => import("../features/chatbot/Deborah"));
const Game = lazy(() => import("../pages/Game"));
const Universe = lazy(() => import("../pages/Universe"));
const DeborahChat = lazy(() => import("../features/chatbot/DeborahChat"));
const AlysonChat = lazy(() => import("../features/chatbot/AlysonChat"));
const JuliaChat = lazy(() => import("../features/chatbot/JuliaChat"));
const Botlist = lazy(() => import("../features/chatbot/BotList"));
const MotherOfWolves = lazy(() => import("../features/stories/motherOfWolves"));
const ScienceTheater = lazy(() => import("../features/stories/scienceTheater"));
const Login = lazy(() => import("../features/auth/Login"));
const Signup = lazy(() => import("../features/auth/Signup"));
const SettingsPage = lazy(() => import("../features/settings/pages/SettingsPage.jsx"));
const Subscription = lazy(() => import("../features/subscription/pages/Subscription.jsx"));
const AdminHome = lazy(() => import("../features/admin/AdminHome"));
const AdminStoryPage = lazy(() => import("../features/admin/AdminStoryPage"));
const StoryAdminPanel = lazy(() => import("../features/admin/StoryAdminPanel"));
const AdminReportsPage = lazy(() => import("../features/admin/AdminReportsPage"));
const LegalPage = lazy(() => import("../features/legal/LegalPage"));
const SupportMe = lazy(() => import("../features/support-me/SupportMe"));

const routes = [
  { path: "/", component: <Home01 />, isPrivate: false },
  { path: "/universe", component: <Universe />, isPrivate: false },
  { path: "/game", component: <Game />, isPrivate: false },
  { path: "/deborah", component: <Deborah />, isPrivate: true },
  { path: "/bot-list", component: <Botlist />, isPrivate: true },
  { path: "/deborah-chat", component: <DeborahChat />, isPrivate: true },
  { path: "/alyson-chat", component: <AlysonChat />, isPrivate: true },
  { path: "/julia-chat", component: <JuliaChat />, isPrivate: true },

  { path: "/mother-of-wolves", component: <MotherOfWolves />, isPrivate: true },
  { path: "/science-theater", component: <ScienceTheater />, isPrivate: true },

  { path: "/contact", component: <Contact />, isPrivate: false },

  { path: "/sign-up", component: <Signup />, isPrivate: false },
  { path: "/log-in", component: <Login />, isPrivate: false },
  { path: "/terms", component: <LegalPage type="terms" />, isPrivate: false },
  { path: "/privacy", component: <LegalPage type="privacy" />, isPrivate: false },
  {
    path: "/refund-policy",
    component: <LegalPage type="refund" />,
    isPrivate: false,
  },
  { path: "/dmca", component: <LegalPage type="dmca" />, isPrivate: false },
  {
    path: "/modern-slavery-content",
    component: <LegalPage type="modernSlavery" />,
    isPrivate: false,
  },
  {
    path: "/2257",
    component: <LegalPage type="section2257" />,
    isPrivate: false,
  },
  { path: "/support-me", component: <SupportMe />, isPrivate: false },
  { path: "/settings", component: <SettingsPage />, isPrivate: true },
  { path: "/subscription", component: <Subscription />, isPrivate: true },
  { path: "/admin", component: <AdminHome />, isAdminOnly: true },
  { path: "/admin/stories", component: <StoryAdminPanel />, isAdminOnly: true },
  { path: "/admin/reports", component: <AdminReportsPage />, isAdminOnly: true },
  {
    path: "/admin/stories/:storySlug",
    component: <AdminStoryPage />,
    isAdminOnly: true,
  },
];

export default routes;
